import { CwtModel, CwtProp } from "@cawita/core-front/api";
import { EvaluationResultEntity } from "./eval-result.entity";
import { QuestionAnswer } from "./question-eval.model";

@CwtModel({ name: 'eval-sleep' })
export class EvalSleep extends EvaluationResultEntity {
    @CwtProp() answerScore: number;
    @CwtProp({ ref: QuestionAnswer }) result: QuestionAnswer[];
}